'use client'

import React, { useEffect, useState } from 'react'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { PartyPopper, ArrowRight, ShieldCheck } from 'lucide-react'

export function VerificationSuccessModal() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const shouldShow = sessionStorage.getItem('show_verification_welcome_modal')
        if (shouldShow === 'true') {
            setIsOpen(true)
            sessionStorage.removeItem('show_verification_welcome_modal')
        }
    }, [])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-[440px] border-none shadow-2xl p-0 overflow-hidden">
                <div className="h-2 bg-gradient-ai w-full" />
                <div className="p-8">
                    <div className="flex justify-center mb-6">
                        <div className="h-20 w-20 rounded-full bg-success-green/10 flex items-center justify-center relative">
                            <PartyPopper className="h-10 w-10 text-success-green animate-bounce" />
                            <div className="absolute -top-1 -right-1 bg-white rounded-full p-1 shadow-sm">
                                <ShieldCheck className="h-6 w-6 text-primary animate-pulse" />
                            </div>
                        </div>
                    </div>

                    <DialogHeader className="text-center space-y-3">
                        <DialogTitle className="text-2xl font-bold text-foreground">
                            Account Verified!
                        </DialogTitle>
                        <DialogDescription className="text-base text-foreground/70">
                            Congratulations! You've successfully verified your identity and your <span className="font-bold text-primary">1 Month Free Starter Plan</span> has been activated.
                        </DialogDescription>
                    </DialogHeader>

                    <div className="mt-8">
                        <Button
                            className="w-full py-6 text-lg font-bold group"
                            onClick={() => setIsOpen(false)}
                            variant="professional"
                        >
                            Sign In Now
                            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                        </Button>
                    </div>

                    <p className="text-center mt-4 text-xs text-muted-foreground italic">
                        Enjoy advanced educational data management
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    )
}
